import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncSolarIconLineDuotone = createAsyncIcon(() => import('./SolarIconLineDuotone'));

export default AsyncSolarIconLineDuotone;

AsyncSolarIconLineDuotone.displayName = 'AsyncSolarIconLineDuotone';
